<template>
	<div class="allergens-selector">
		<ModalHeader
			:title="getString('choose_allergens')"
			:button-text="getString('confirm')"
			@click-button="confirmSelection" />
		<div class="allergens-content">
			<div class="allergens-grid">
				<div 
					v-for="allergen in allergensList" 
					:key="allergen.allergen_id"
					class="allergen-item"
					:class="{ selected: isAllergenSelected(allergen) }"
					:style="'--allergen-color: #' + allergen.color"
					@click="toggleAllergen(allergen)">
					<div class="allergen-icon">
						<img :src="getAllergenIconUrl(allergen)" :alt="getString(allergen.name_key)">
					</div>
					<div class="allergen-name">{{ getString(allergen.name_key) }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore} from "@/shared/stores";
import {useUnchangingStore} from "@/console-new/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const unchangingStore = useUnchangingStore();
		return {getString: languageStore.getString, unchangingStore};
	},
	name: "AllergensSelector",
	components: {ModalHeader},
	emits: ["confirm-selection"],
	props: {
		selectedAllergens: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			tempSelectedAllergens: []
		};
	},
	computed: {
		allergensList() {
			return this.unchangingStore.orderedAllergens;
		}
	},
	created() {
		// Copia gli allergeni selezionati per modifiche temporanee
		this.tempSelectedAllergens = [...this.selectedAllergens];
	},
	methods: {
		getAllergenIconUrl(allergen) {
			const iconName = allergen.name_key.replace('allergens_', '');
			return `${URL_HTML}/img/allergens/icon-${iconName}.php?c=${allergen.color}`;
		},
		isAllergenSelected(allergen) {
			return this.tempSelectedAllergens.some(a => a.allergen_id === allergen.allergen_id);
		},
		toggleAllergen(allergen) {
			const index = this.tempSelectedAllergens.findIndex(a => a.allergen_id === allergen.allergen_id);
			if (index > -1) {
				this.tempSelectedAllergens.splice(index, 1);
			} else {
				this.tempSelectedAllergens.push(allergen);
			}
		},
		confirmSelection() {
			this.$emit('confirm-selection', this.tempSelectedAllergens);
		}
	}
}
</script>

<style scoped lang="scss">
.allergens-selector {
	display: flex;
	flex-direction: column;
	height: 100%;
	
	.allergens-content {
		flex: 1;
		overflow-y: auto;
		padding: 20px 10px;
		
		.allergens-grid {
			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
			gap: 12px;
			
			@media (min-width: 768px) {
				grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
				gap: 16px;
			}
			
			.allergen-item {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 12px 8px;
				border-radius: 12px;
				cursor: pointer;
				transition: all 0.2s ease;
				position: relative;
				background-color: transparent;
				
				&::before {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					border-radius: 12px;
					border: 2px solid var(--allergen-color);
					background-color: var(--color-alpha-1);
					opacity: 0.2;
					transition: opacity 0.2s ease;
					pointer-events: none;
				}
				
				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
				}
				
				&.selected {
					&::before {
						opacity: 1;
					}
					
					.allergen-icon {
						transform: scale(1.1);
					}
				}
				
				.allergen-icon {
					width: 40px;
					height: 40px;
					margin-bottom: 8px;
					transition: transform 0.2s ease;
					position: relative;
					z-index: 1;
					
					img {
						width: 100%;
						height: 100%;
						object-fit: contain;
					}
				}
				
				.allergen-name {
					font-size: 12px;
					line-height: 1.2;
					text-align: center;
					color: var(--color-txt);
					word-break: break-word;
					position: relative;
					z-index: 1;
					
					@media (min-width: 768px) {
						font-size: 13px;
					}
				}
			}
		}
	}
}
</style>